import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';

// Initialize highcharts-more module for columnrange
if (typeof Highcharts === 'object') {
  HighchartsMore(Highcharts);
}

function parseTimestamp(ts) {
  // Try to parse ISO string, fallback to 0 if invalid
  const d = Date.parse(ts);
  return isNaN(d) ? 0 : d;
}

const NodeTimeRangeGraph = ({ energyData = [] }) => {
  if (energyData?.NodeEnergySummaries === undefined) return null;
  // Prepare data for columnrange: [x, min, max]
  const categories = energyData.NodeEnergySummaries.map((node) => node.Name);
  const data = energyData.NodeEnergySummaries.map((node, idx) => {
    const min = parseTimestamp(node.TimestampsSummary.minEarliestDataTimestamp);
    const max = parseTimestamp(node.TimestampsSummary.maxLatestDataTimestamp);
    return {
      x: idx,
      low: min,
      high: max,
      name: node.Name,
    };
  });

  const options = {
    chart: {
      type: 'columnrange',
      inverted: true,
      height: Math.max(300, energyData.NodeEnergySummaries.length * 50),
    },
    title: {
      text: 'Node Data Time Ranges',
    },
    xAxis: {
      categories,
      title: { text: 'Node' },
    },
    yAxis: {
      type: 'datetime',
      title: { text: 'Timestamp' },
    },
    tooltip: {
      pointFormat:
        '<b>{point.name}</b><br/>From: {point.low:%Y-%m-%d %H:%M}<br/>To: {point.high:%Y-%m-%d %H:%M}',
    },
    series: [
      {
        name: 'Data Range',
        data,
      },
    ],
    plotOptions: {
      columnrange: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return Highcharts.dateFormat('%Y-%m-%d', this.y);
          },
        },
      },
    },
    credits: { enabled: false },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default NodeTimeRangeGraph;
